import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { UtilsTypes, ActionsChainInterface } from './types';

// Dispatch Actions Chain
export const dispatchActionsChainRequest = (payload: ActionsChainInterface[]) =>
  action(UtilsTypes.DISPATCH_ACTIONS_CHAIN_REQUEST, payload);
export const dispatchActionsChainSuccess = () =>
  action(UtilsTypes.DISPATCH_ACTIONS_CHAIN_SUCCESS);
export const dispatchActionsChainFailure = () =>
  action(UtilsTypes.DISPATCH_ACTIONS_CHAIN_FAILURE);
